// Numeric
export const numericValidator = value => !/[^0-9]/.test(value)
export const numericFormatter = value => value.replace(/[^0-9]/, '')

// AlphaNumeric
export const alphaNumericValidator = value => !/[^a-zA-Z0-9]/.test(value)
export const alphaNumericFormatter = value => value.replace(/[^a-zA-Z0-9]/, '')

// AlphaNumericSpace
export const alphaNumericSpaceValidator = value => !/[^a-zA-Z0-9 ]/.test(value)
export const alphaNumericSpaceFormatter = value => value.replace(/[^a-zA-Z0-9 ]/, '')
